import { connect } from 'react-redux';
import PayButton from './Pay';

const mapStateToProps = (state) => ({
    order: state.form.order,

    firstName: state.payment.firstName,
    lastName: state.payment.lastName,
    email: state.payment.email,
    phone: state.payment.phone,
    shipLocation: state.payment.storeLocation,
    deliveryOption: state.payment.deliveryOption,

    shippingInfo: state.shipping,

    concessionData: state.form.concessionInfo,
})

const mapDispatchToProps = (dispatch) => ({

})

export default connect (mapStateToProps, mapDispatchToProps)(PayButton);